var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-chevron-down.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.78027 11.0303L9.00002 7.81052L12.2198 11.0303L13.2803 9.96977L9.00002 5.68952L4.71977 9.96977L5.78027 11.0303Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropActiveIcon);
export default __webpack_public_path__ + "static/media/drop-active_icon.6f9bc3bda0f83061423c6bee8863509e.svg";
export { ForwardRef as ReactComponent };